module.exports = __webpack_public_path__ + "img/8.0e997ec0.png";